import { required } from "vuelidate/lib/validators";

export default class PosData {
  descricao = "";
  serial_pos = "";
  username = "";
  password = "";
  modelo = null;
  id_configuracao_pos = null;
  status = true;
  nuts_pay = false;
  usar_smart_tef = false;
  smart_tef_token = "";
  smart_tef_gateway_token = "";
  smart_tef_configurado = false;

  constructor({ 
    descricao = "", 
    serial_pos = "", 
    modelo = null, 
    id_configuracao_pos = null, 
    status = true,
    username = "",
    password = "",
    nuts_pay = "",
    usar_smart_tef = false,
    smart_tef_configurado = false,
  }) {
    this.descricao = descricao;
    this.serial_pos = serial_pos;
    this.modelo = modelo;
    this.id_configuracao_pos = id_configuracao_pos;
    this.status = status;
    this.username = username;
    this.password = password;
    this.nuts_pay = nuts_pay;
    this.usar_smart_tef = usar_smart_tef;
    this.smart_tef_configurado = smart_tef_configurado;
  }
}

export const PosDataRequired = {
  descricao: {
    required,
  },
  serial_pos: {
    required,
  },
};
